(function() {
  var btn = document.getElementById('tmt-size-recommend-btn');
  if (!btn) return;

  btn.addEventListener('click', function() {
    var height = parseFloat(document.getElementById('tmt-height-input').value);
    var weight = parseFloat(document.getElementById('tmt-weight-input').value);
    var resultEl = document.getElementById('tmt-size-recommend-result');

    if (!height || !weight) {
      resultEl.style.display = 'block';
      resultEl.innerHTML = '<span class="tmt-size-recommend__error">身長と体重を入力してください。</span>';
      return;
    }

    var table = document.querySelector('.size_recommend');
    if (!table) {
      resultEl.style.display = 'block';
      resultEl.innerHTML = '<span class="tmt-size-recommend__error">サイズデータが見つかりません。</span>';
      return;
    }

    var rows = table.querySelectorAll('tr');
    var sizeList = [];

    for (var i = 1; i < rows.length; i++) {
      var cells = rows[i].querySelectorAll('td');
      if (cells.length < 3) continue;
      sizeList.push({
        size: cells[0].textContent.trim(),
        heightRange: cells[1].textContent.trim(),
        weightRange: cells[2].textContent.trim()
      });
    }

    // 身長・体重それぞれでマッチするサイズを探す
    var heightMatchIndex = -1;
    var weightMatchIndex = -1;
    var bothMatchIndex = -1;

    for (var j = 0; j < sizeList.length; j++) {
      var hMatch = parseRange(sizeList[j].heightRange, height);
      var wMatch = parseRange(sizeList[j].weightRange, weight);
      if (hMatch && wMatch && bothMatchIndex === -1) bothMatchIndex = j;
      if (hMatch && heightMatchIndex === -1) heightMatchIndex = j;
      if (wMatch && weightMatchIndex === -1) weightMatchIndex = j;
    }

    var html = '';
    var justSize = null;
    var looseSize = null;

    if (bothMatchIndex !== -1) {
      // 両方一致：通常表示
      justSize = sizeList[bothMatchIndex].size;
      looseSize = (bothMatchIndex + 1 < sizeList.length) ? sizeList[bothMatchIndex + 1].size : null;

      html += '<p class="tmt-size-recommend__label">ジャストサイズ</p>';
      html += '<p class="tmt-size-recommend__size">' + justSize + '</p>';
      html += '<p class="tmt-size-recommend__label tmt-size-recommend__label--sub">ゆったりサイズ</p>';
      html += '<p class="tmt-size-recommend__size tmt-size-recommend__size--sub">' + (looseSize || '-') + '</p>';

    } else if (heightMatchIndex !== -1 || weightMatchIndex !== -1) {
      // 身長・体重が別サイズにマッチ
      var hSize = heightMatchIndex !== -1 ? sizeList[heightMatchIndex].size : '-';
      var wSize = weightMatchIndex !== -1 ? sizeList[weightMatchIndex].size : '-';

      // GA4・Klaviyo用にjustSizeを設定（体重優先）
      justSize = wSize !== '-' ? wSize : hSize;

      html += '<p class="tmt-size-recommend__label">身長基準</p>';
      html += '<p class="tmt-size-recommend__size">' + hSize + '</p>';
      html += '<p class="tmt-size-recommend__label tmt-size-recommend__label--sub">体重基準</p>';
      html += '<p class="tmt-size-recommend__size tmt-size-recommend__size--sub">' + wSize + '</p>';
      html += '<p class="tmt-size-recommend__note tmt-size-recommend__note--caution">身長と体重で異なるサイズが該当しました。大きい方のサイズをお選びいただくことをおすすめします。</p>';

    } else {
      html = '<span class="tmt-size-recommend__error">該当するサイズが見つかりませんでした。</span>';
    }

    html += '<p class="tmt-size-recommend__note">当社規定の身長・体重のみを基準にした目安のサイズ感となります。<br>当社では、180㎝/70kgをLサイズとして提供しています。<br>スタイリングや個々の体型によっては目安とならない場合がございます。</p>';

    resultEl.style.display = 'block';
    resultEl.innerHTML = html;

    // 商品名を取得
    var productName = document.querySelector('h1') ? document.querySelector('h1').textContent.trim() : '';
    var productUrl = window.location.href;

    // GA4イベント送信
    if (justSize && typeof window.gtag === 'function') {
      window.gtag('event', 'size_recommend', {
        'product_name': productName,
        'url': productUrl,
        'height': height,
        'weight': weight,
        'height_size': heightMatchIndex !== -1 ? sizeList[heightMatchIndex].size : 'none',
        'weight_size': weightMatchIndex !== -1 ? sizeList[weightMatchIndex].size : 'none',
        'just_size': bothMatchIndex !== -1 ? sizeList[bothMatchIndex].size : 'split',
        'loose_size': looseSize || 'none'
      });
    }

    // Klaviyoイベント送信
    if (justSize && typeof window._learnq !== 'undefined') {
      window._learnq.push(['track', 'Size Recommend', {
        'Product': productName,
        'URL': productUrl,
        'Height': height,
        'Weight': weight,
        'Height Size': heightMatchIndex !== -1 ? sizeList[heightMatchIndex].size : 'none',
        'Weight Size': weightMatchIndex !== -1 ? sizeList[weightMatchIndex].size : 'none',
        'Just Size': bothMatchIndex !== -1 ? sizeList[bothMatchIndex].size : 'split',
        'Loose Size': looseSize || 'none'
      }]);
    }
  });

  function parseRange(rangeStr, value) {
    var parts = rangeStr.replace(/[^0-9\-]/g, '').split('-');
    var min = parts[0] !== '' ? parseFloat(parts[0]) : -Infinity;
    var max = parts[1] !== undefined && parts[1] !== '' ? parseFloat(parts[1]) : Infinity;
    return value >= min && value <= max;
  }
})();
